import { App } from '../App';
import { Base64 } from 'js-base64';
import { getFetchHeaders } from '../utils/fetchHeaders';
import { routes } from '../routes';
import { SESSION_TINK_REASON } from 'utils/constants';
import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

type SendReportsParams = {
  loanApplicationId: number;
  transactionReportId: string;
  riskInsightsId: string;
};

export default function useTink() {
  const apiTinkInquiries = App.useApi('client/tink/inquiries', 'POST');
  const location = useLocation();
  const navigate = useNavigate();

  const getLink = useCallback((isIFrame = false) => {
    const params = {
      client_id: `${process.env.REACT_APP_TINK_CLIENT_ID}`,
      redirect_uri: `${window.location.origin}${routes.FirstLoan_OnlineBank_Check}`,
      market: 'ES',
      locale: 'es_ES',
      report_types: 'RISK_INSIGHTS_REPORT,TRANSACTION_REPORT',
      test: `${process.env.REACT_APP_TINK_CLIENT_USE_TEST_BANK === 'true'}`,
      iframe: `${isIFrame}`,
      theme: 'LIGHT', // force light mode
    };

    const url = new URL('https://link.tink.com/1.0/reports/create-report');

    for (const [key, value] of Object.entries(params)) {
      url.searchParams.append(key, value);
    }

    return url;
  }, []);

  const sendReportIds = useCallback(async (params: SendReportsParams) => {
    try {
      await apiTinkInquiries.fetch({
        headers: getFetchHeaders(),
        body: {
          productName: 'vivus.es',
          ...params,
        },
      });
    } catch (e) {
      throw e;
    }
  }, []);

  const handleTinkV2Error = useCallback(() => {
    const searchParams = new URLSearchParams(location.search);

    const errorReason = searchParams.get('error_reason');

    if (errorReason === 'REQUEST_FAILED_CREATE_REPORT') {
      sessionStorage.setItem(SESSION_TINK_REASON, Base64.encode(errorReason));
      navigate(routes.FirstLoan_OnlineBank_DocumentsRequired);
      return;
    }

    const errorParam = searchParams.get('error');

    if (errorParam === 'USER_CANCELLED') {
      navigate(routes.FirstLoan_OnlineBank_Verify);
      return;
    }

    if (errorParam && errorParam !== 'USER_CANCELLED') {
      navigate(`${routes.FirstLoan_OnlineBank_Error}?${searchParams}`);
      // eslint-disable-next-line no-console
      console.error(
        'Tink error. Search params',
        decodeURIComponent(location.search),
      );
    }
  }, []);

  return {
    getLink,
    sendReportIds,
    handleTinkV2Error,
  };
}
